export const environment = {
  production: false,
  apiUrl: 'https://develop.pitts.app/api/',
  socketsUrl: 'https://develop.pitts.app',
  socketsPath: '/web-sockets/socket.io',
  krPublicKey: "90656095:testpublickey_9wHSxu8KdoywseNPaT5vJkwQwdChypvtPGpVxtRr2z7GK",
  stripePublishableKey: "pk_test_51Lo91jEkxW8eBsvVJxBxJnThTa9KDOW1oWdqiG9mYK2Sif33rm0UjrxHIOAhcdN9vTz2OsRXuW01swipglbkqvVd00pUdrkMOU"
};
